/** Fee per payment method. wallet_account PERCENT is an MDR deducted from gross → gross up. */
export interface FeeMethod {
  paymentType: string;
  paymentFee: number;
  paymentFeeUnit: string;
}

export function calcPaymentFee(method: FeeMethod | null, grandTotal: number): number {
  if (!method) return 0;
  if (method.paymentFeeUnit === 'PERCENT') {
    const rate = method.paymentFee / 100;
    if (method.paymentType.toLowerCase() === 'wallet_account') {
      return Math.ceil(grandTotal / (1 - rate) - grandTotal);
    }
    return Math.ceil(grandTotal * rate);
  }
  if (method.paymentFeeUnit === 'AMOUNT') return method.paymentFee;
  return 0;
}
